export const listExportsForCommitteeIdQuery = `
    query ListExportsForCommitteeId($committeeId: String!) {
        listExportsForCommitteeId(committeeId: $committeeId) {
            adminEmployeeId
            adminName
            committeeId
            datetimeCompleted
            datetimeStarted
            executionId
            recommendations {
                count
                filename
                recommendation
                isComplete
                updatedByEmployeeId
                updatedByName
                updatedDatetime
                downloadedBy
                downloadedByName
                downloadedDatetime
            }
            status
            requestAddtlInfo
        }
    }
`;

export const listExportsForCommitteeIdsQuery = `
    query ListExportsForCommitteeIds($committeeIds: [String!]!) {
        listExportsForCommitteeIds(committeeIds: $committeeIds) {
            adminEmployeeId
            adminName
            committeeId
            datetimeCompleted
            datetimeStarted
            executionId
            recommendations {
                count
                filename
                recommendation
                isComplete
                updatedByEmployeeId
                updatedByName
                updatedDatetime
                downloadedBy
                downloadedByName
                downloadedDatetime
            }
            status
            requestAddtlInfo
        }
    }
`;

export const getDownloadableLinkForPathsQuery = `
    query GetDownloadableLinkForPaths($filenames: [String!], $committeeId: String, $recommendationKey: String, $executionIds: [String]) {
        getDownloadableLinkForPaths(filenames: $filenames, committeeId: $committeeId, recommendationKey: $recommendationKey, executionIds: $executionIds) {
            status
            details
            error {
                message
                date
            }
        }
    }
`;